import { Type } from 'class-transformer';

import { IPagination } from './utils';

export class IPackageDesiChangeUpload {
  id: number;
  userId: number;
  status: number;
  fileSize: number;
  fileType: string;
  packageDesiChangeId: string;
  packageId: number;
  date: string;
  fileUrl?: string;
  fileId: string;
}

export class IPackageDesiChange {
  id: string;
  packageId: number;
  barcode: string;
  boxcode: string;
  companyId: number;
  companyName: string;
  companyCity?: string;
  companySubcity?: string;
  vendorId: number;
  vendorName: string;
  vendorCity?: string;
  vendorSubcity?: string;
  senderId: number;
  senderName: string;
  senderCity?: string;
  senderSubcity?: string;
  oldDesi: number;
  newDesi: number;
  changedByUserId: number;
  changedByUserName: string;
  /** Değiştiren kullanıcının bölgeleri (xdock bölge yetkisi, okuma anında) */
  changedByUserRegion?: string[];
  changeReason: string;
  /** Kaynak (Okutmada Sıfır Desi planı §5-1). Eski kayıtlarda yok → changeReason ile sınıflanır */
  source?: 'scan_zero' | 'quick_desi' | 'manual';
  /** Okutma ekranı (yalnız source=scan_zero) */
  screen?: string;
  /** Okutma bağlamındaki sefer ID'si (yalnız source=scan_zero) */
  routeSessionId?: number;
  imageUrls: string[];
  @Type(() => IPackageDesiChangeUpload)
  uploads?: IPackageDesiChangeUpload[];
  createdAt: string;
  updatedAt: string;
}

export class IPackageDesiChangeListResponse extends IPagination {
  @Type(() => IPackageDesiChange)
  results: IPackageDesiChange[];
}

export class IPackageDesiChangeDownloadResponse {
  result: string;
}

export interface IPackageDesiChangeQueryDto {
  page?: number;
  limit?: number;
  packageId?: number;
  barcode?: string;
  companyId?: number | number[];
  vendorId?: number;
  senderId?: number;
  changedByUserId?: number;
  /** Değiştiren kullanıcının bölgesi (bolge=999 nokta id) */
  regionId?: number;
  /** scan_zero = Okutma (sıfır desi), quick_desi = Hızlı Desi, manual = Elle */
  source?: 'scan_zero' | 'quick_desi' | 'manual';
  dateCreatedStart?: string;
  dateCreatedEnd?: string;
}
